export const mixedBox = {
	methods: {
		$_mixedBox_boxesInBox (params) {
			if (!params.menu) return
			if (!params.recipes_id) return
			var mixedBoxesIds = [] 
			params.menu.recipes.forEach(recipe => {
				if (recipe.isMixedBox) {
					mixedBoxesIds.push(recipe.id)
				}
			})

			return params.recipes_id.filter(element => mixedBoxesIds.includes(element)).length
		},

		$_mixedBox_isOrderHasMixedBox (params) {
			if (!params.menu) return
			if (!params.recipes_id) return
			return this.$_mixedBox_boxesInBox(params) >= 1
		}
	}
		
}
